import React from "react";
import {IconButton, InputAdornment} from "@material-ui/core";
import TextField2 from "./TextField2";
import {Visibility,VisibilityOff} from '@material-ui/icons';
 const PasswordField =({placeholder,handleChange,value, Textlabel, disabled})=>{
    const [values, setValues] = React.useState({
        password:value,
        showPassword: false,
      });
      const handleClickShowPassword = () => {
        setValues({ ...value, showPassword: !values.showPassword });
      };
    
      const handleMouseDownPassword = (event:any) => {
        event.preventDefault();
      };
    return(
      <TextField2  onChange={handleChange} placeholder={placeholder}
      id="standard-basic"
      type={values.showPassword ? 'text' : 'password'}
      value={value}
      Textlabel={Textlabel}
      disabled={disabled}
      inputProps={{
        endAdornment: (
                <InputAdornment position="end">
                    <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    >
                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                </InputAdornment>
            ),
          maxLength:12
      }}
      />
    )
}
export default PasswordField;